import { render, staticRenderFns } from "./wechatKfConsole.vue?vue&type=template&id=ff92d5e0&scoped=true"
import script from "./wechatKfConsole.vue?vue&type=script&lang=js"
export * from "./wechatKfConsole.vue?vue&type=script&lang=js"
import style0 from "./wechatKfConsole.vue?vue&type=style&index=0&id=ff92d5e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff92d5e0",
  null
  
)

export default component.exports